import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import {
    HIDE_MODAL,
    MODAL_TYPE_LOGIN,
    MODAL_TYPE_REGISTER,
    MODAL_TYPE_ADBLOCKER,
    MODAL_TYPE_DISENROL,
    MODAL_TYPE_INFORMATIVE,
    MODAL_TYPE_INTERSTITIEL,
    MODAL_TYPE_KYC
} from '../../services/modal/constants';

import AdBlockerModal from '../adblocker/AdBlockerModal';
import CloseButtonComponent from '../button/CloseButtonComponent';
import InformativeModal from '../informativemodal/InformativeModal';
import LoginModalComponent from '../authentication/login/LoginModalComponent';
import RegisterModalComponent from '../authentication/register/RegisterModalComponent';
import DisenrolModalComponent from '../authentication/disenrollment/DisenrolModalComponent';
import InterstitielModalComponent from '../pages/interstitiel/InterstitielModalComponent';
import KycModal from '../fraud/kyc/KycModal';

import './ModalRoot.scss';

// Chaque nouvelle Modal spécifique doit être ajoutée ici
const MODAL_COMPONENTS = {
    [MODAL_TYPE_REGISTER]: RegisterModalComponent,
    [MODAL_TYPE_LOGIN]: LoginModalComponent,
    [MODAL_TYPE_INTERSTITIEL]: InterstitielModalComponent,
    [MODAL_TYPE_ADBLOCKER]: AdBlockerModal,
    [MODAL_TYPE_INFORMATIVE]: InformativeModal,
    [MODAL_TYPE_DISENROL]: DisenrolModalComponent,
    [MODAL_TYPE_KYC]: KycModal
};

const ModalRoot = ({
    modal,
    dispatch,
    location,
    injectCloseButton,
    redirectOnClose,
    redirectToUrl,
    actionOnClose,
    id,
    ariaLabel
}) => {
    const hideModal = () => {
        dispatch({ type: HIDE_MODAL });
    };

    if (!modal.modalType) {
        return null;
    }

    const SpecificModal = MODAL_COMPONENTS[modal.modalType];
    const isLarge = modal.modalType === MODAL_TYPE_ADBLOCKER;

    const onCloseButton = () => {
        hideModal();
        if (actionOnClose) {
            actionOnClose();
        }
    };

    const renderCloseButton = () => {
        if (injectCloseButton) {
            if (redirectOnClose && !isEmpty(redirectToUrl)) {
                return (
                    <a href={redirectToUrl}>
                        <CloseButtonComponent onClick={onCloseButton} />
                    </a>
                );
            } else {
                return <CloseButtonComponent onClick={onCloseButton} />;
            }
        }
    };

    const renderBlocker = () => {
        return <div className="blocker" />;
    };

    return (
        <div>
            {renderBlocker()}
            <div
                className={`modal-container flex-container-v flex-center conteneur-mobile ${
                    isLarge ? 'large' : ''
                }`}>
                <div
                    id={id ? id : ''}
                    className="modal"
                    tabIndex="-1"
                    role="dialog"
                    aria-label={ariaLabel ? ariaLabel : ''}
                    aria-modal="true">
                    <SpecificModal {...modal.modalProps} currentPath={location.pathname} />
                    {renderCloseButton()}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        modal: state.modal,
        injectCloseButton: !state.modal.modalProps || !state.modal.modalProps.hideCloseButton,
        location: state.routing.location,
        redirectOnClose: state.modal.modalProps && state.modal.modalProps.redirectOnClose,
        redirectToUrl: state.modal.modalProps && state.modal.modalProps.redirectToUrl,
        actionOnClose: state.modal.modalProps && state.modal.modalProps.actionOnClose,
        id: state.modal.modalProps && state.modal.modalProps.id,
        ariaLabel: state.modal.modalProps && state.modal.modalProps.ariaLabel
    };
};

export default connect(mapStateToProps)(ModalRoot);



// WEBPACK FOOTER //
// ./src/components/modal/ModalRoot.js